import React, { useState } from 'react';
import { Star, Search } from 'lucide-react';
import productListData from './Data/ProductListData';

function SecondSection() {
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [isZoomed, setIsZoomed] = useState(false);

  const categories = [
    { id: 'all', name: 'Semua Produk' },
    { id: 'shampoo', name: 'Shampoo' },
    { id: 'conditioner', name: 'Conditioner' },
    { id: 'serum', name: 'Serum' },
    { id: 'hair mask', name: 'Hair Mask' },
    { id: 'hair spa', name: 'Hair Spa' },
  ];

  // Handle mouse/touch movement
  const handlePointerMove = (e, index) => {
    e.preventDefault();
    const container = e.currentTarget;
    const { left, top, width, height } = container.getBoundingClientRect();
    
    // Get coordinates for both mouse and touch events
    const clientX = e.clientX || (e.touches && e.touches[0].clientX);
    const clientY = e.clientY || (e.touches && e.touches[0].clientY);
    
    if (clientX && clientY) {
      const x = ((clientX - left) / width) * 100;
      const y = ((clientY - top) / height) * 100;
      setMousePosition({ x, y });
    }
  };

  // Handle touch start
  const handleTouchStart = (index) => {
    setHoveredIndex(index);
    setIsZoomed(true);
  };

  // Handle touch end
  const handleTouchEnd = () => {
    setHoveredIndex(null);
    setIsZoomed(false);
  };

  const filteredProducts = productListData.filter(product => {
    const matchesSearch = product.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
      product.description.toLowerCase().includes(searchQuery.toLowerCase());
    const matchesCategory = selectedCategory === 'all' || product.category === selectedCategory;
    return matchesSearch && matchesCategory;
  });

  return (
    <div className="min-h-screen py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">Produk Papakilo Hairstudio</h1>
          <p className="text-xl text-gray-600">Koleksi Produk Styling & Perawatan Rambut Premium</p>
        </div>

        {/* Search and Filter */}
        <div className="mb-8">
          <div className="flex flex-col md:flex-row gap-4 justify-between items-center">
            <div className="relative w-full md:w-96">
              <input
                type="text"
                placeholder="Cari produk..."
                className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
              <Search className="absolute left-3 top-2.5 h-5 w-5 text-gray-400" />
            </div>
            <div className="w-full md:w-auto overflow-x-auto scroll-smooth" id='no-scrollbar'>
              <div className="flex gap-2 pb-2 whitespace-nowrap">
                {categories.map(category => (
                  <button
                    key={category.id}
                    onClick={() => setSelectedCategory(category.id)}
                    className={`px-4 py-2 rounded-full text-sm font-medium
                      ${selectedCategory === category.id
                        ? 'bg-blue-600 text-white'
                        : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
                      }`}
                  >
                    {category.name}
                  </button>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Products Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {filteredProducts.map((product, index) => (
            <div 
              key={index} 
              className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-xl transition-shadow duration-300"
            >
              <div 
                className="relative w-full h-72 overflow-hidden touch-none"
                onMouseEnter={() => setHoveredIndex(index)}
                onMouseLeave={() => setHoveredIndex(null)}
                onMouseMove={(e) => handlePointerMove(e, index)}
                onTouchStart={() => handleTouchStart(index)}
                onTouchMove={(e) => handlePointerMove(e, index)}
                onTouchEnd={handleTouchEnd}
              >
                <img
                  src={product.image}
                  alt={product.name}
                  className="absolute w-full h-full object-contain transition-transform duration-200 cursor-zoom-in"
                  style={{
                    transform: hoveredIndex === index ? 'scale(2.5)' : 'scale(1)',
                    transformOrigin: `${mousePosition.x}% ${mousePosition.y}%`,
                    touchAction: 'none'
                  }}
                />
              </div>
              <div className="p-6">
                <div className="flex justify-between items-start mb-2">
                  <h3 className="text-xl font-semibold text-gray-900">{product.name}</h3>
                  <div className="flex items-center">
                    <Star className="w-5 h-5 text-yellow-400 fill-current" />
                    <span className="ml-1 text-gray-600">{product.rating}</span>
                  </div>
                </div>
                <p className="text-gray-600 mb-4 capitalize">{product.description}</p>
                <div className="flex justify-between items-center">
                  <div className="text-2xl font-bold text-blue-600">{product.price}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default SecondSection;